import { Component, EventEmitter, HostListener, Input, OnDestroy, Output } from '@angular/core';
import {FieldMetaTypeGuards} from '../../../interfaces/FieldMetaTypeGuards';
import { IFieldMeta } from '../../../interfaces/imetadata';
import { FieldConfig } from '../../../utils/fieldconfig';
import { FieldType } from '../../../utils/fieldtype';
import { DIR, Sort } from '../../../utils/sort';

@Component({
    selector: 'app-field-config',
    templateUrl: './field-config.component.html',
    styleUrls: ['./field-config.component.scss'],
    standalone: false
})
export class FieldConfigComponent implements OnDestroy {

  readonly FieldType: typeof FieldType = FieldType;
  readonly FieldMetaTypeGuards = FieldMetaTypeGuards;

  @Input()
  set field(field: IFieldMeta | undefined) {
    this.theField = field;
  }

  get field(): IFieldMeta | undefined {
    return this.theField;
  }

  @Input()
  set fields(fields: IFieldMeta[] | undefined) {
    this.sortedFields = fields?.sort(this.sortFieldMeta);
  }

  @Input()
  config: FieldConfig = {};

  @Output()
  configChange = new EventEmitter<FieldConfig>();

  @Output()
  closeEvent = new EventEmitter<void>();

  theField: IFieldMeta | undefined;
  sortedFields: IFieldMeta[] | undefined = [];

  constructor() {}

  ngOnDestroy() {
    this.config = {};
  }

  closeFieldConfig() {
    this.fireCloseConfigEvent();
  }

  isAssociatedField(fieldType: string): boolean {
    return fieldType === FieldType.TO_MANY || fieldType === FieldType.TO_ONE || fieldType === FieldType.COMPOSITE;
  }

  private sortFieldMeta(a: IFieldMeta, b: IFieldMeta): number {
    return Sort.sortString(a.label, b.label, DIR.ASC);
  }

  private fireCloseConfigEvent(): void {
    this.closeEvent.emit();
  }

  @HostListener('document:keydown', ['$event'])
  protected handleKeydownEvent(event: KeyboardEvent) {
    if (event.code === 'Escape') {
      this.closeFieldConfig();
    }
  }
}
